import * as Types from '../../types/gql';

export type InstrumentFragment = {
  type: Types.ClearingDepositInstrumentType;
  currency: string;
  minimum?: Types.Maybe<number>;
  maximum?: Types.Maybe<number>;
  details?: Types.Maybe<
    | { __typename: 'ClearingAbroadBankDepositDetails' }
    | { __typename: 'ClearingBankCardPaymentSystem'; id: number; fee: number }
    | {
        __typename: 'ClearingProviderWalletTransferPaymentSystem';
        id: number;
        name: string;
        fee: number;
      }
    | { __typename: 'ClearingRussianBankDepositDetails' }
  >;
};

export type DepositInstrumentsVariables = Types.Exact<{ [key: string]: never }>;

export type DepositInstruments = {
  clearing?: Types.Maybe<{ depositInstruments?: Types.Maybe<Array<InstrumentFragment>> }>;
};
